import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { getOrders } from 'components/graphql/queries'
import { openModal } from 'components/modal/modules/dispatcher/methods';

import { Text } from 'components/common/form/modules/input/Text';

import React, { useCallback, useEffect, useState } from 'react'
import Moment from "react-moment";
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';

import {
    Card,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';

// import Checkin from '../Checkin/Validate';

// import EmailsModal from './Emails';
import OrderControls from './OrderControls'

const OrdersTable: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const [campaignId] = useState(props.campaignId)
    const [loading, setLoading] = useState(true)
    const [orders, setOrders] = useState<any[]>([])
    const [searchTerm, setSearchTerm] = useState('')

    const [selectedUserName, setSelectedUserName] = useState(props.selectedUserName)

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getOrders,
                variables: {
                    campaignId,
                    username: selectedUserName
                }
            })
            .then(res => {
                setLoading(false)
                setOrders(res.data.data.order.getByCampaignId)
            })
            .catch(err => {
                console.log(err)
            })

    }, [setLoading, campaignId, props.user, setOrders, selectedUserName])

    const openOrderControlsModal = useCallback((code) => {
        const content = <OrderControls
            code={code}
            campaignId={campaignId}
            reloadData={() => props.reloadData()}
        />
        openModal(content, '#' + code, [props.reloadData])
    }, [campaignId, props.reloadData])

    const usersIncludingCurrentUser: any[] =
        props.user.isAdmin || props.createdBy.toString().trim() === props.user.id
            ? [props.createdByUsername]
            : [props.user.username]
    props.users.map((u: any) => {
        usersIncludingCurrentUser.push(u)
    })
    const affiliates = usersIncludingCurrentUser.map((item, ind) => {
        return <DropdownItem key={ind} onClick={() => {
            props.setSelectedUserName(item)
            setSelectedUserName(item)
            setSearchTerm('')
        }}>
            {item}
        </DropdownItem>
    })

    if (loading) {
        return null;
    }

    let filteredOrders: any[] = []
    if (searchTerm.trim() !== '') {
        filteredOrders = orders.filter((order: any) => {
            if (order.buyerName.trim().split(' ').join('').toLowerCase().includes(searchTerm)) {
                return true
            } else {
                return false
            }
        })
    } else {
        filteredOrders = orders
    }

    return <div>
        <Card style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <p style={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                <div style={{ flex: 1, flexDirection: screen.width < 768 ? 'column' : 'row', display: 'flex' }}>
                    <div style={{ float: 'left', width: 'auto', display: 'flex', flexDirection: 'row' }}>
                        <span>View orders for</span>
                        <span>
                            <UncontrolledDropdown style={{ paddingLeft: '10px', marginTop: '-4px' }}>
                                <DropdownToggle
                                    className='new-button-white-4'
                                    data-toggle="dropdown"
                                    tag='button'
                                >
                                    {selectedUserName}  ▼
                                </DropdownToggle>
                                <DropdownMenu style={{ borderRadius: '10px' }}>
                                    <DropdownItem header={true}>Team Member</DropdownItem>
                                    {affiliates}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </span>
                    </div>
                    <div style={{ flex: 1 }}>
                        <span style={{ flex: 1, textAlign: 'right', paddingLeft: 25, paddingRight: 25 }}>
                            <Text
                                placeholder="Search"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value.toLowerCase())}
                                required={true}
                            />
                        </span>
                    </div>
                    <div style={{ float: 'right', marginLeft: 35 }}>
                        {
                            props.user.isAdmin || props.createdBy.toString().trim() === props.user.id.toString().trim() ?
                                <span style={{ flex: 1, textAlign: 'right' }}>
                                    <a href={API_ENDPOINTS.BASE_URL + 'report/orders/' + campaignId}>
                                        <button className='new-button-cancel' style={{ marginTop: '4px', paddingRight: '20px' }}>Download</button>
                                    </a>
                                </span> : null
                        }
                    </div>
                </div>
            </p>
            <div style={{
                overflow: "scroll", paddingTop: '10px', // maxHeight: '550px'
            }}>
                {
                    orders.length > 0 ?
                        <table className='table-responsive--base m-0' style={{ minWidth: '375px', textAlign: 'left', fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <td>NAME</td>
                                    <td>REVENUE</td>
                                    <td>QTY</td>
                                    <td>SOLD BY</td>
                                    <td>ID</td>
                                    <td>TIME</td>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: '13px' }}>
                                {
                                    filteredOrders.map((item: any, index: number) => {
                                        return <tr key={index} onClick={() => {
                                            if (item.status === 'bought') {
                                                openOrderControlsModal(item.code)
                                            }
                                        }} style={{ cursor: item.status === 'bought' ? 'pointer' : 'not-allowed' }}>
                                            <td className='sexyBlack'>
                                                {item.buyerName}
                                            </td>
                                            <td
                                                style={{
                                                    color: (
                                                        item.status === 'DISPUTED' ? '#d63191' : (
                                                            item.status === 'bought' ? '#242d51' : '#565e81'
                                                        )
                                                    )
                                                }}
                                            >
                                                {
                                                    item.status === 'bought' ?
                                                        '$' + ((item.revenue) / 100).toFixed(2) :
                                                        item.status
                                                }
                                            </td>
                                            <td>
                                                {item.totalCount}
                                            </td>
                                            <td>
                                                {
                                                    item.sellerName.includes("-additional-link-") ?
                                                        (item.sellerName.split("-")[0] + " (link #" + (Number(item.sellerName.split("-")[3]) + 2).toString() + ")") : item.sellerName
                                                }
                                            </td>
                                            <td>
                                                {item.code}
                                            </td>
                                            <td className='gray-text' style={{ fontSize: '9px' }}>
                                                <Moment format="D MMM 'YY, ">
                                                    {item.boughtAt}
                                                </Moment>
                                                <Moment format="hh:mm A">
                                                    {item.boughtAt}
                                                </Moment>
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table> :
                        <p style={{ width: '100%', textAlign: 'center' }}>
                            No tickets purchased
                        </p>
                }
            </div>
        </Card>
    </div >
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(OrdersTable);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/OrdersTable.tsx